import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	space__list: 'mw/admin/space/list',
	space__rules: 'mw/admin/space/rules',
	space__rule__add: 'mw/admin/space/rule/add',
	space__rule__del: 'mw/admin/space/rule/del',
	space__table__list: 'mw/admin/space/table/list',
	space__rule__info: 'mw/admin/space/rule/info',
	space__rule__set: 'mw/admin/space/rule/set',
	space__restr: 'mw/admin/space/restr',
	space__restr__info: 'mw/admin/space/restr/info',
	space__restr__set: 'mw/admin/space/restr/set',
	space__restr__del: 'mw/admin/space/restr/del',
	space__attr__restr: 'mw/admin/space/attr/restr',
	space__column__list: 'mw/admin/space/column/list',
	space__condition__list: 'mw/admin/space/condition/list',
};

export const spaceApi = createApi({
	reducerPath: 'mw/admin/spaceApi',

	endpoints: (builder) => ({
		spaceList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/space/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.space__list],
		}),
		spaceRules: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/space/rules?${qs.stringify(body)}`,
			}),
			providesTags: [tags.space__rules],
		}),
		spaceRulesAdd: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/admin/space/rule/add',
				body,
				jsonType: true,
			}),
			providesTags: [tags.space__rule__add],
		}),
		spaceRulesDel: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/admin/space/rule/del',
				body,
				jsonType: true,
			}),
			providesTags: [tags.space__rule__del],
		}),
		spaceTableList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/space/table/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.space__table__list],
		}),
		spaceRuleInfo: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/admin/space/rule/info',
				body,
				jsonType: true,
			}),
			providesTags: [tags.space__rule__info],
		}),
		spaceRuleSet: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: `/mw/admin/space/rule/set?${qs.stringify(body)}`,
			}),
			providesTags: [tags.space__rule__set],
		}),
		spaceRestr: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/space/restr?${qs.stringify(body)}`,
			}),
			providesTags: [tags.space__restr],
		}),
		spaceRestrInfo: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/space/restr/info?${qs.stringify(body)}`,
			}),
			providesTags: [tags.space__restr__info],
		}),
		spaceRestrSet: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/admin/space/restr/set',
				body,
				jsonType: true,
			}),
			providesTags: [tags.space__restr__set],
		}),
		spaceRestrDel: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/admin/space/restr/del',
				body,
			}),
			providesTags: [tags.space__restr__del],
		}),
		spaceAttrRestr: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/space/attr/restr?${qs.stringify(body)}`,
			}),
			providesTags: [tags.space__attr__restr],
		}),
		spaceColumnList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/space/column/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.space__column__list],
		}),
		spaceConditionList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/space/condition/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.space__condition__list],
		}),
	}),
});

export const {
	spaceList,
	spaceRules,
	spaceRulesAdd,
	spaceRulesDel,
	spaceTableList,
	spaceRuleInfo,
	spaceRuleSet,
	spaceRestr,
	spaceRestrInfo,
	spaceRestrSet,
	spaceRestrDel,
	spaceAttrRestr,
	spaceColumnList,
	spaceConditionList,
} = spaceApi.endpoints;

export default spaceApi;